import * as React from 'react';
import { connect } from 'react-redux';

import Spinner from 'components/spinner/Spinner';
import StatisticsAudienceOverlapError from 'modules/statistics/components/StatisticsAudienceOverlapError';
import TooManyFollowersMessage from 'modules/statistics/components/TooManyFollowersMessage';

import { AUDIENCE_OVERLAP_STATUSES } from 'modules/statistics/reducers/statistics-audience-overlap';

type OwnProps = {
  children: React.ReactNode,
  actionButton?: React.ReactNode
};

type StateProps = {
  overlapStatus: string
};

type Props = OwnProps & StateProps;

function renderError(overlapStatus: string, actionButton): React.ReactNode {
  if (overlapStatus === 'too_many_profiles') {
    return <TooManyFollowersMessage actionButton={actionButton} />;
  }

  return <StatisticsAudienceOverlapError error={overlapStatus} />;
}

const StatisticsAudienceOverlapStatusChecker = ({
  actionButton,
  overlapStatus,
  children
}: Props) => {
  let content: React.ReactNode = null;

  if (overlapStatus === AUDIENCE_OVERLAP_STATUSES.LOADING) {
    content = (
      <Spinner
        position="inline"
        size="small"
        color="light"
      />
    );
  } else if (overlapStatus === AUDIENCE_OVERLAP_STATUSES.AVAILABLE) {
    content = children;
  } else {
    content = renderError(overlapStatus, actionButton);
  }

  return (
    <div>
      {content}
    </div>
  );
};

const mapStateToProps = ({ statisticsAudienceOverlap }): StateProps => ({
  overlapStatus: statisticsAudienceOverlap.overlapStatus
});

export default connect(mapStateToProps)(StatisticsAudienceOverlapStatusChecker);
